import React from "react";
import Header from "../../components/Header";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import LoginForm from "../../components/LoginForm";
import { Navigate } from "react-router-dom";
import Perfil from "../../components/Perfil";
import { useParams } from "react-router-dom";

export default function PerfilPage() {
  const { id } = useParams();

  const [login, setLogin] = useState(false);
  let thisUser = useSelector((state) => state.user);

  useEffect(() => {

    if(id === "null"){
    document.title = "Login";
      
    }
    else{
      document.title = id;
    }

    if (thisUser.username) {
      setLogin(true);
    } else {
      setLogin(false);
    }
  }, [id, thisUser, thisUser.username]);

  return (
    <>
      <Header />

      { !login && id === "null" ? <LoginForm/> : login && id === "null" ? <Navigate to={`/authors/${thisUser.username}`} /> : <Perfil username={id} />} 
      
    </>
  );
}


